import * as React from 'react';
import {Card,CardContent, Typography}  from '@mui/material';
import { format } from 'date-fns';
import ListItemText from "@mui/material/ListItemText";
import ListItem from "@mui/material/ListItem";
import List from "@mui/material/List";

interface Props {
    profilazione: Profilazione
}
const ProfilazioneLead: React.FC<Props> = ({profilazione}) => {
    const items = profilazione.contenutoHtml
        ?.split("|")
        .map(item => item.trim())
        .filter(item => item.length > 0);
// export default function CardLead(paramLead: Lead) {
    return (
        <Card sx={{maxHeight: 500, overflow: 'auto'}}>
            <CardContent>
                <Typography variant="h5" component="div">
                    Profilazione del Lead
                </Typography>
                <Typography sx={{ mb: 1.5 }} color="text.secondary">
                    Questa profilazione è effettuata in base alle risposte ottenute nel Quiz introduttivo.
                </Typography>
                <Typography variant="body2">
                    <List sx={{ listStyleType: "disc", pl: 3 }}>
                        {items?.map((item, index) => (
                            <ListItem
                                key={index}

                                sx={{
                                    display: "list-item",
                                    textAlign: "justify",
                                    pt: .5,
                                    pb: .5

                                }}
                            >
                                <ListItemText primary={item} />
                            </ListItem>
                        ))}
                    </List>
                </Typography>

            </CardContent>
        </Card>
    );
}
export default ProfilazioneLead;